module.exports = __webpack_public_path__ + "static/media/edit-icon.244e9bc7.svg";